import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { theme } from '../constants/theme'
import { StyleProps, createStyles } from '../utils/create-styles'
import {
  DisplayProps,
  OpacityProps,
  SpaceProps,
  TypographyProps,
  display,
  fontSize,
  opacity,
  space,
  typography,
} from '../utils/styled-system'

export type BaseTextProps = {
  className?: string
  noEllipsis?: boolean
  noSelect?: boolean
  noWrap?: boolean
}

export type TextProps = BaseTextProps &
  DisplayProps &
  OpacityProps &
  SpaceProps &
  TypographyProps & {
    bold?: boolean
    children?: ReactNode
    color?: string
    size?: TextSizeInput
    styles?: StyleProps
    textDecoration?: 'underline'
  }

// TODO(rb): use the `Enumerable` type from `@bemlo/ui`
export type TextSizeInput =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 5.5
  | 6
  | 6.5
  | (0 | 1 | 2 | 3 | 4 | 5 | 5.5 | 6 | 6.5)[]

export const Text = (props: TextProps) => {
  const { bold, children, color, size, noSelect } = props

  const TextElement = styled(bold ? 'strong' : 'span')({
    ...display(props),
    ...opacity(props),
    ...space(props),
    ...typography(props),
    ...(size !== undefined &&
      fontSize({
        fontSize: Array.isArray(size)
          ? size.map((s) => theme.font.size[s])
          : theme.font.size[size],
      })),
    color,
    maxWidth: props.noWrap ? '100%' : undefined,
    overflow: props.noWrap && !props.noEllipsis ? 'hidden' : undefined,
    textDecoration: props.textDecoration,
    textOverflow: props.noWrap ? 'ellipsis' : undefined,
    whiteSpace: props.noWrap ? 'nowrap' : undefined,
    userSelect: noSelect ? 'none' : undefined,
    ...createStyles(props.styles),
  })

  return <TextElement className={props.className}>{children}</TextElement>
}
